import {
  QUALIFIER_CONFIG_SUCCESS,
  FETCH_START,
  FETCH_END,
  EDI_MAPPINGS_SUCCESS,
  PRICE_TYPE_CONFIG_SUCCESS,
  PRICE_QUALIFIER_NAME_SUCCESS,
  PRICE_NEW_QUALIFIER_NAME_SUCCESS,
  GLOBAL_CONTRACT_CONFIG_BY_APP_TYPE,
  GLOBAL_CONTRACT_CONFIG_BY_CONTRACT_TYPE,
  CUSTOM_TABLE_FIELDS_SUCCESS,
  PRICE_TYPE_NAME_SUCCESS,
  PRICE_LIST_MASTER_SUCCESS,
  PRICE_LIST_MASTER_BY_ID,
  PRICE_LIST_DATA_BY_ID,
  PRICE_LIST_DATA_SUCCESS,
  RESET_PRICE_LIST_DATA,
  PRICE_MAINTENANCE_FIELDS,
  PRICE_MAINTENANCE_FIELDS_NEW,
  DISTINCT_PRICE_LIST_DATA,
  PRICE_FORMULA_BY_ID,
  PRICE_FORMULA_SUCCESS,
  LIST_DATA_FORMAT_SUCCESS,
  LIST_DATA_FORMAT_BY_ID,
  OFF_INVOICE_CONFIG_SUCCESS,
  CONF_EDI_MAPPINGS_SUCCESS,
  CONF_ID_EDI_MAPPINGS_SUCCESS,
  PRICE_CAL_FOR_LIST_SUCCESS,
  PRICE_CAL_FOR_LIST_BY_ID,
  PRICE_CAL_FOR_LIST_BY_NAME,
  PRICE_CAL_FOR_SIMULATION_SUCCESS,
  PRICE_CHANGE_HISTORY_DATA_SUCCESS,
  SIMULATION_DROPDOWN_SUCCESS,
  PRICE_ELASTICITY,
  PRICE_SIMULATION_DATA_SUCCESS,
  PRICE_CATALOG_DATA_SUCCESS,
  PRICE_HISTORY_SUCCESS,
  PRICE_HISTORY_BY_ID_SUCCESS,
  PRICE_SIM_RESULTS_SUCCESS,
  LIST_DATA_UPLOAD_FAILURE,
  CUSTOMER_MARGIN_SUCCESS,
  PRICE_POLICY_EXCEP,
  DISTINCT_PROFIT_LIST_DATA,
  COMPREHENCIVE_QUOTE_DATA,
  COMPREHENCIVE_QUOTE_DATA_BY_ID,
  PRICE_SIMULATION_LIST_DATA,
  PRICE_SIMULATION_DATA_BY_ID,
  PRICE_CATALOG_LIST_DATA,
  PRICE_MAINTENANCE_FIELDS_BY_PRICE_TYPE,
  PRICE_LIST_DATA_MESSAGELOG,
  PRICE_UNIQUE_SUCCESS,
  PRICE_FILTER_DATA,
  CATALOG_FILTER_DATA,
  PRICE_CATALOG_SUCCESS,
  PRICE_ADJUST_SUCCESS,
  PRICE_REQUEST_CONFIG_BY_ID,
  PRICE_REQUEST_CONFIG_SUCCESS,
  PRICE_SIMULATION_CONFIG_BY_ID,
  PRICE_SIMULATION_CONFIG_SUCCESS,
  PRICE_CATALOG_CONFIG_SUCCESS,
  PRICE_CATALOG_CONFIG_BY_ID,
  PRICE_REASON_CODE_CONFIG_SUCCESS,
  PRICE_CONTRACTS_LIST,
  PRICE_CONTRACT_ID,
  PRICE_CONTRACTS,
  PRICE_REQUESTS_SUCCESS,
  PRICE_REQUESTS_BY_ID_SUCCESS,
  RESET_PRICE_MAINTENANCE_FIELDS,
  PRICE_CONTRACT_APPROVAL,
  PRICE_PROFILE_SELECTION_SUCCESS,
  QUOTE_CONFIGURATION_SUCCESS,
  CLEAR_QUOTE_CONFIGURATION,
  LAYOUT_DATA_SUCCESS,
  PRICE_WORKFLOW_NAME_SUCCESS,
  PRICE_PROFILE_SELECTION_BY_ID,
  PRICE_PROFILE_SELECTION_ATTRIBUTES,
  PRICE_WORKFLOW_NEXT_STATUS_SUCCESS,
  PRICE_WORKFLOW_STATUS_SUCCESS,
  CLEAR_WORKFLOW_STATUS_DATA,
  WORKFLOW_STATUS,
  PRICE_CONTRACT_FIELDS,
  PRICE_LAYOUT_SUCCESS,
  PRICE_LAYOUT_BY_ID_SUCCESS,
  PRICE_PROFILE_CONFIGURATION_SUCCESS,
  PRICE_PROFILE_CONFIGURATION_BY_ID,
  PRICE_LAYOUT_BY_QUOTE_SUCCESS,
  PRICE_LAYOUT_BY_DOCUMENT_SUCCESS,
  PRICE_POINTS_SUCCESS,
  PRICE_POINTS_BY_ID,
  PRICE_POINTS_BY_NAME,
  PRICE_POINT_EXECUTE_SUCCESS,
  PRICE_POINT_EXECUTE_ERROR,
  CLEAR_PRICE_POINT_EXECUTE_RESULT,
  PRICE_LIST_CONFIG,
  SET_SELECTED_PRICE_LIST_BY_RULE,
  SET_UNSAVED_PRICE_CHANGES,
  CLEAR_UNSAVED_PRICE_CHANGES,
} from '../../actions/Pricing/ActionTypes';

const initialState = {
  loading: false,
  qualifierConfigData: [],
  edimappingData: [],
  priceTypeData: [],
  priceQualifierNameList: [],
  priceNewQualifierNameList: [],
  globalContractConfigData: [],
  globalContractConfigContractTypeData: [],
  priceTypeNameList: [],
  priceListMasterData: [],
  priceListMasterSingleData: [],
  priceListData: [],
  priceListSingleData: [],
  priceMaintenanceFields: [],
  priceMaintenanceFieldsNew: [],
  distinctPriceList: [],
  priceFormulaList: [],
  priceFormulaSingle: [],
  listDataUploadFormat: [],
  listDataUploadFormatById: {},
  offInvoiceConfigData: [],
  configEdiMappingsData: [],
  idConfigEdiMappingsData: [],
  priceCalForListData: [],
  priceListCalForSingleData: [],
  priceListCalForDataByName: [],
  priceCalForSimulationData: [],
  priceChangeHistoryData: [],
  simulationNumberDropdown: [],
  priceElasticityData: [],
  priceCalForErrorList: [],
  priceSimResultData: [],
  priceCatalogDataSuccess: [],
  listDataUploadError: [],
  customerMarginData: [],
  customerMarginErrorList: [],
  pricePolicyExcepData: [],
  distinctProfitList: [],
  comprehensiveQuoteData: [],
  comprehensiveQuoteSingleData: [],
  comprehensiveQuoteData: [],
  priceSimulationNewListData: [],
  priceSimulationListSingleData: [],
  pricingFields: [],
  priceListMessageLog: [],
  uniquePriceData: [],
  priceFilterData: {},
  catalogFilterData: {},
  catalogReport: {},
  priceAdjustSimulationReport: {},
  priceRequestListData: [],
  priceRequestSingleData: [],
  priceSimulationSingleData: [],
  priceSimulationListData: [],
  priceCatalogConfigData: [],
  priceCatalogSingleData: [],
  priceReasonCodeListData: [],
  priceContractList: [],
  priceContractId: {},
  priceRequests: [],
  priceRequestDetail: [],
  priceContracts: [],
  priceContractApprovalList: [],
  priceProfileSelectioData: [],
  priceProfileSelectioSingleData: [],
  profileSelectionAttributes: [],
  quoteConfigurationData: [],
  layoutData: [],
  historyData: [],
  allcontractsFields: [],
  workflowNameData: [],
  workflowNextStatusData: [],
  workflowStatusData: [],
  workflowStatuses: {},
  getPriceRequestMassUpdate: [],
  priceLayout: [],
  priceLayoutById: [],
  priceProfileConfigData: [],
  priceProfileConfigSingleData: [],
  dataLoader: false,
  priceRequestLoading: false,
  pricePointExecuteResult: {},
  pricePointExecuteError: null,
  priceListConfig: {},
  selectedPriceListByRule: {},
  unsavedPriceChanges: {},
  simulationLoading: false
};

const PricingReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_PRICE_MAINTENANCE_FIELDS:
      return {
        ...state,
        priceMaintenanceFields: [],
        priceTypeNameList: [],
        priceListMasterData: [],
        priceTypeData: [],
        priceRequestListData: [],
        pricingFields: [],
        priceListData: [],
      };
    case QUALIFIER_CONFIG_SUCCESS:
      return {
        ...state,
        qualifierConfigData: action.data,
        loading: false,
      };
    case FETCH_START:
      return {
        ...state,
        ...(action.item ? { [action.item]: true } : { loading: true }),
      };
    case FETCH_END:
      return {
        ...state,
        ...(action.item ? { [action.item]: false } : { loading: false }),
      };
    case PRICE_TYPE_CONFIG_SUCCESS:
      return {
        ...state,
        priceTypeData: action.data,
        loading: false,
      };
    case EDI_MAPPINGS_SUCCESS:
      return {
        ...state,
        edimappingData: action.data,
        loading: false,
      };
    case PRICE_QUALIFIER_NAME_SUCCESS:
      return {
        ...state,
        priceQualifierNameList: action.data,
        loading: false,
      };
    case PRICE_NEW_QUALIFIER_NAME_SUCCESS:
      return {
        ...state,
        priceNewQualifierNameList: action.data,
        loading: false,
      };
    case GLOBAL_CONTRACT_CONFIG_BY_APP_TYPE:
      return {
        ...state,
        globalContractConfigData: action.data,
        loading: false,
      };
    case GLOBAL_CONTRACT_CONFIG_BY_CONTRACT_TYPE:
      return {
        ...state,
        globalContractConfigContractTypeData: action.data,
        loading: false,
      };
    case CUSTOM_TABLE_FIELDS_SUCCESS:
      return {
        ...state,
        customTableFieldData: action.data,
        loading: false,
      };
    case PRICE_TYPE_NAME_SUCCESS:
      return {
        ...state,
        priceTypeNameList: action.data,
        loading: false,
      };
    case PRICE_LIST_MASTER_SUCCESS:
      return {
        ...state,
        priceListMasterData: action.data,
        loading: false,
      };
    case PRICE_LIST_MASTER_BY_ID:
      return {
        ...state,
        priceListMasterSingleData: action.data,
        loading: false,
      };
    case PRICE_LIST_DATA_BY_ID:
      return {
        ...state,
        priceListSingleData: action.data,
        loading: false,
      };
    case PRICE_LIST_DATA_SUCCESS:
      return {
        ...state,
        priceListData: action.data,
        loading: false,
      };
    case PRICE_MAINTENANCE_FIELDS:
      return {
        ...state,
        priceMaintenanceFields: action.data,
        loading: false,
      };
    case PRICE_MAINTENANCE_FIELDS_NEW:
      return {
        ...state,
        priceMaintenanceFieldsNew: action.data,
        loading: false,
      };
    case DISTINCT_PRICE_LIST_DATA:
      return {
        ...state,
        distinctPriceList: action.data,
        loading: false,
      };
    case PRICE_FORMULA_BY_ID:
      return {
        ...state,
        priceFormulaSingle: action.data,
        loading: false,
      };
    case PRICE_FORMULA_SUCCESS:
      return {
        ...state,
        priceFormulaList: action.data,
        loading: false,
      };
    case LIST_DATA_FORMAT_SUCCESS:
      return {
        ...state,
        listDataUploadFormat: action.data,
        loading: false,
      };
    case LIST_DATA_FORMAT_BY_ID:
      return {
        ...state,
        listDataUploadFormatById: action.data,
        loading: false,
      };
    case OFF_INVOICE_CONFIG_SUCCESS:
      return {
        ...state,
        offInvoiceConfigData: action.data,
        loading: false,
      };
    case CONF_EDI_MAPPINGS_SUCCESS:
      return {
        ...state,
        configEdiMappingsData: action.data,
        loading: false,
      };
    case CONF_ID_EDI_MAPPINGS_SUCCESS:
      return {
        ...state,
        idConfigEdiMappingsData: action.data,
        loading: false,
      };
    case PRICE_CAL_FOR_LIST_SUCCESS:
      return {
        ...state,
        priceCalForListData: action.data,
        loading: false,
      };
    case PRICE_CAL_FOR_LIST_BY_ID:
      return {
        ...state,
        priceListCalForSingleData: action.data,
        loading: false,
      };
    case PRICE_CAL_FOR_LIST_BY_NAME:
      return {
        ...state,
        priceListCalForDataByName: action.data,
        loading: false,
      };
    case PRICE_CAL_FOR_SIMULATION_SUCCESS:
      return {
        ...state,
        priceCalForSimulationData: action.data,
        priceCalForErrorList: action.errorList,
      };
    case PRICE_CHANGE_HISTORY_DATA_SUCCESS:
      return {
        ...state,
        priceChangeHistoryData: action.data,
        loading: false,
      };
    case SIMULATION_DROPDOWN_SUCCESS:
      return {
        ...state,
        simulationNumberDropdown: action.data,
      };
    case PRICE_ELASTICITY:
      return {
        ...state,
        priceElasticityData: action.data,
      };
    case PRICE_SIMULATION_DATA_SUCCESS:
      return {
        ...state,
        priceSimulationDataSuccess: action.data,
      };
    case PRICE_CATALOG_DATA_SUCCESS:
      return {
        ...state,
        priceCatalogDataSuccess: action.data,
      };
    case PRICE_SIM_RESULTS_SUCCESS:
      return {
        ...state,
        priceSimResultData: action.data,
        loading: false,
      };
    case RESET_PRICE_LIST_DATA:
      return {
        ...state, // Keep other parts of the state unchanged
        priceListMasterData: [], // Reset price list data
        priceMaintenanceFields: [], // Reset maintenance fields
      };
    case LIST_DATA_UPLOAD_FAILURE:
      return {
        ...state,
        listDataUploadError: action.data,
        loading: false,
      };
    case CUSTOMER_MARGIN_SUCCESS:
      return {
        ...state,
        customerMarginData: action.data,
        customerMarginErrorList: action.errorList,
      };
    case PRICE_POLICY_EXCEP:
      return {
        ...state,
        pricePolicyExcepData: action.data,
        loading: false,
      };
    case DISTINCT_PROFIT_LIST_DATA:
      return {
        ...state,
        distinctProfitList: action.data,
        loading: false,
      };
    case COMPREHENCIVE_QUOTE_DATA:
      return {
        ...state,
        comprehensiveQuoteData: action.data,
        loading: false,
      };
    case COMPREHENCIVE_QUOTE_DATA_BY_ID:
      return {
        ...state,
        comprehensiveQuoteSingleData: action.data,
        loading: false,
      };
    case PRICE_SIMULATION_LIST_DATA:
      return {
        ...state,
        priceSimulationNewListData: action.data,
        loading: false,
      };
    case PRICE_SIMULATION_DATA_BY_ID:
      return {
        ...state,
        priceSimulationListSingleData: action.data,
        loading: false,
      };
    case PRICE_CATALOG_LIST_DATA:
      return {
        ...state,
        priceCatalogListData: action.data,
        loading: false,
      };
    case PRICE_MAINTENANCE_FIELDS_BY_PRICE_TYPE:
      return {
        ...state,
        pricingFields: action.data,
        loading: false,
      };
    case PRICE_LIST_DATA_MESSAGELOG:
      return {
        ...state,
        priceListMessageLog: action.data,
      };
    case PRICE_UNIQUE_SUCCESS:
      return {
        ...state,
        uniquePriceData: action.data,
      };
    case PRICE_FILTER_DATA:
      return {
        ...state,
        priceFilterData: action.data,
      };
    case CATALOG_FILTER_DATA:
      return {
        ...state,
        catalogFilterData: action.data,
      };
    case PRICE_CATALOG_SUCCESS:
      return {
        ...state,
        catalogReport: action.data,
      };
    case PRICE_ADJUST_SUCCESS:
      return {
        ...state,
        priceAdjustSimulationReport: action.data,
      };
    case PRICE_REQUEST_CONFIG_BY_ID:
      return {
        ...state,
        priceRequestSingleData: action.data,
        loading: false,
      };
    case PRICE_REQUEST_CONFIG_SUCCESS:
      return {
        ...state,
        priceRequestListData: action.data,
        loading: false,
      };
    case PRICE_SIMULATION_CONFIG_BY_ID:
      return {
        ...state,
        priceSimulationSingleData: action.data,
        loading: false,
      };
    case PRICE_SIMULATION_CONFIG_SUCCESS:
      return {
        ...state,
        priceSimulationListData: action.data,
        loading: false,
      };
    case PRICE_CATALOG_CONFIG_SUCCESS:
      return {
        ...state,
        priceCatalogConfigData: action.data,
        loading: false,
      };
    case PRICE_CATALOG_CONFIG_BY_ID:
      return {
        ...state,
        priceCatalogSingleData: action.data,
        loading: false,
      };
    case PRICE_REASON_CODE_CONFIG_SUCCESS:
      return {
        ...state,
        priceReasonCodeListData: action.data,
        loading: false,
      };
    case PRICE_CONTRACTS_LIST:
      return {
        ...state,
        priceContractList: action.data,
        loading: false,
      };
    case PRICE_CONTRACT_ID:
      return {
        ...state,
        priceContractId: action.data,
        loading: false,
      };
    case PRICE_CONTRACTS:
      return {
        ...state,
        priceContracts: action.data,
        loading: false,
      };
    case PRICE_REQUESTS_SUCCESS:
      return {
        ...state,
        priceRequests: action.data,
        priceRequestLoading: action.loader,
      };
    case PRICE_REQUESTS_BY_ID_SUCCESS:
      console.log('tests', action.data);
      return {
        ...state,
        priceRequestDetail: action.data,
        loading: false,
      };
    case PRICE_CONTRACT_APPROVAL:
      return {
        ...state,
        priceContractApprovalList: action.data,
        loading: false,
      };
    case PRICE_PROFILE_SELECTION_SUCCESS:
      return {
        ...state,
        priceProfileSelectioData: action.data,
        loading: false,
      };
    case PRICE_PROFILE_SELECTION_BY_ID:
      return {
        ...state,
        priceProfileSelectioSingleData: action.data,
        loading: false,
      };
    case PRICE_PROFILE_SELECTION_ATTRIBUTES:
      return {
        ...state,
        profileSelectionAttributes: action.data,
        loading: false,
      };
    case QUOTE_CONFIGURATION_SUCCESS:
      return {
        ...state,
        quoteConfigurationData: action.data,
        loading: false,
      };
    case CLEAR_QUOTE_CONFIGURATION:
      return {
        ...state,
        quoteConfigurationData: [],
        loading: false,
      };
    case LAYOUT_DATA_SUCCESS:
      return {
        ...state,
        layoutData: action.data,
        loading: false,
      };
    case PRICE_WORKFLOW_NAME_SUCCESS:
      return {
        ...state,
        workflowNameData: action.data,
        loading: false,
      };
    case PRICE_WORKFLOW_STATUS_SUCCESS:
      return {
        ...state,
        workflowStatusData: action.data,
        loading: false,
      };
    case CLEAR_WORKFLOW_STATUS_DATA:
      return {
        ...state,
        workflowStatusData: {},
        workflowNextStatusData: {},
      };
    case PRICE_WORKFLOW_NEXT_STATUS_SUCCESS:
      return {
        ...state,
        workflowNextStatusData: action.data,
        loading: false,
      };
    case WORKFLOW_STATUS:
      return {
        ...state,
        workflowStatuses: action.data,
      };
    case PRICE_CONTRACT_FIELDS:
      return {
        ...state,
        allcontractsFields: action.data,
        loading: false,
      };
    case PRICE_LAYOUT_SUCCESS:
      return {
        ...state,
        priceLayout: action.data,
      };
    case PRICE_LAYOUT_BY_ID_SUCCESS:
      return {
        ...state,
        priceLayoutById: action.data,
      };
    case PRICE_PROFILE_CONFIGURATION_SUCCESS:
      return {
        ...state,
        priceProfileConfigData: action.data,
        loading: false,
      };
    case PRICE_PROFILE_CONFIGURATION_BY_ID:
      return {
        ...state,
        priceProfileConfigSingleData: action.data,
        loading: false,
        dataLoader: action.loader,
      };
    case PRICE_LAYOUT_BY_QUOTE_SUCCESS:
      return {
        ...state,
        priceLayoutByQuote: action.data,
        loading: false,
      };
    case PRICE_LAYOUT_BY_DOCUMENT_SUCCESS:
      return {
        ...state,
        priceLayoutByDocument: action.data,
        loading: false,
      };
    case PRICE_POINTS_SUCCESS:
      return {
        ...state,
        pricePointsData: action.data,
        loading: false,
      };
    case PRICE_HISTORY_SUCCESS:
      return {
        ...state,
        historyData: action.data,
        loading: false,
      };
    case PRICE_POINTS_BY_ID:
      return {
        ...state,
        pricePointById: action.data,
        loading: false,
      };
    case PRICE_POINTS_BY_NAME:
      return {
        ...state,
        pricePointByName: action.data,
        loading: false,
      };
    case PRICE_HISTORY_BY_ID_SUCCESS:
      return {
        ...state,
        pricePointExecuteResult: action.data,
        pricePointExecuteError: null,
        loading: false,
      };
    case PRICE_POINT_EXECUTE_SUCCESS:
      return {
        ...state,
        pricePointExecuteResult: action.data,
        pricePointExecuteError: null,
        loading: false,
      };
    case PRICE_POINT_EXECUTE_ERROR:
      return {
        ...state,
        pricePointExecuteError: action.error,
        loading: false,
      };
    case CLEAR_PRICE_POINT_EXECUTE_RESULT:
      return {
        ...state,
        pricePointExecuteResult: {},
        pricePointExecuteError: null,
      };
    case PRICE_LIST_CONFIG:
      return {
        ...state,
        priceListConfig: action.data,
      };
    case SET_SELECTED_PRICE_LIST_BY_RULE:
      return {
        ...state,
        selectedPriceListByRule: {
          ...state.selectedPriceListByRule,
          [action.ruleName]: action.priceListId,
        },
      };
    case SET_UNSAVED_PRICE_CHANGES:
      return {
        ...state,
        unsavedPriceChanges: {
          ...state.unsavedPriceChanges,
          ...action.changes,
        },
      };
    case CLEAR_UNSAVED_PRICE_CHANGES:
      return {
        ...state,
        unsavedPriceChanges: {},
      };
    default:
      return state;
  }
};

export default PricingReducer;
